<ng-container [ngSwitch]="type">
    <button *ngSwitchDefault mat-button [color]="getColor()" [routerLink]="settings.routerLink">
        <ng-container *ngTemplateOutlet="butContent"></ng-container>
    </button>
    <button *ngSwitchCase="'raised'" mat-raised-button [color]="getColor()" [routerLink]="settings.routerLink">
        <ng-container *ngTemplateOutlet="butContent"></ng-container>
    </button>
    <button *ngSwitchCase="'stroked'" mat-stroked-button [color]="getColor()" [routerLink]="settings.routerLink">
        <ng-container *ngTemplateOutlet="butContent"></ng-container>
    </button>
    <button *ngSwitchCase="'flat'" mat-flat-button [color]="getColor()" [routerLink]="settings.routerLink">
        <ng-container *ngTemplateOutlet="butContent"></ng-container>
    </button>
    <button *ngSwitchCase="'icon'" mat-icon-button [color]="getColor()" [routerLink]="settings.routerLink">
        <ng-container *ngTemplateOutlet="butContent"></ng-container>
    </button>
    <button *ngSwitchCase="'fab'" mat-fab [color]="getColor()" [routerLink]="settings.routerLink">
        <ng-container *ngTemplateOutlet="butContent"></ng-container>
    </button>
    <button *ngSwitchCase="'mini-fab'" mat-mini-fab [color]="getColor()" [routerLink]="settings.routerLink">
        <ng-container *ngTemplateOutlet="butContent"></ng-container>
    </button>
</ng-container>


<ng-template #butContent>
    <div class="flex items-center justify-center p-0 m-0">
        <mat-icon *ngIf="settings.icon" [svgIcon]="settings.icon"></mat-icon>
        <span *ngIf="text" class="ml-2 min-w-fit">{{ text }} </span>
    </div>
</ng-template>
